import { apiRequest, ApiResponse } from '../request'

export interface PaymentData {
    companyId: number
    partnerId?: number
    paymentMethod: 'CREDIT_CARD' | 'PIX'
    planId?: number
    packCode?: string
    customPackType?: string
    customPackQuantity?: number
    authorizeRecurringPayment?: boolean
    enableRecurring?: boolean
    recurringDueDay?: number
    recurringConsent?: boolean
    customerData?: {
        name: string
        cpfCnpj: string
        email: string
        phone: string
        address: string
        addressNumber: number
        complement?: string
        province: string
        postalCode: string
        city: string
    }
    creditCard?: {
        holderName: string
        number: string
        expiryMonth: string
        expiryYear: string
        ccv: string
    }
    creditCardHolderInfo?: {
        name: string
        email: string
        cpfCnpj: string
        postalCode: string
        addressNumber: string
        addressComplement?: string
        phone: string
        mobilePhone?: string
    }
    installmentCount?: number
    installmentValue?: number
}

export interface RecurringPurchase {
    id: number
    purchaseType: 'PACK' | 'SUBSCRIPTION' | 'BILLING'
    packType?: string
    packCode?: string
    quantity?: number
    planId?: number
    amountCents: number
    dueDay: number
    status: 'ACTIVE' | 'PAUSED' | 'CANCELLED'
    creditCardNumber?: string
    creditCardBrand?: string
    lastChargeDate?: string
    nextChargeDate?: string
    failedAttempts: number
    consentDate?: string
    billingData?: any
    metadata?: any
    createdAt: string
}

export async function createPayment(
    data: PaymentData
): Promise<ApiResponse<any>> {
    return apiRequest<any>('payment', { data }, 'post')
}

export async function getPixData(paymentId: string): Promise<ApiResponse<any>> {
    return apiRequest<any>(`payment/${paymentId}/pix`, {}, 'get')
}

export async function listRecurringPurchases(): Promise<
    ApiResponse<RecurringPurchase[]>
> {
    return apiRequest<RecurringPurchase[]>(
        'payment/recurring-purchases',
        {},
        'get'
    )
}

export async function cancelRecurringPurchase(
    id: number
): Promise<ApiResponse<any>> {
    return apiRequest<any>(
        `payment/recurring-purchases/${id}/cancel`,
        {},
        'patch'
    )
}

export async function pauseRecurringPurchase(
    id: number
): Promise<ApiResponse<any>> {
    return apiRequest<any>(
        `payment/recurring-purchases/${id}/pause`,
        {},
        'patch'
    )
}

export async function resumeRecurringPurchase(
    id: number
): Promise<ApiResponse<any>> {
    return apiRequest<any>(
        `payment/recurring-purchases/${id}/resume`,
        {},
        'patch'
    )
}
